import React from 'react';
import PropTypes from 'prop-types';

const QRCode = require('qrcode.react');

const PrintMac = props => {
    const { boxId } = props;
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <QRCode value={boxId} renderAs="svg" size={70} />
        </div>
    );
};

PrintMac.propTypes = {
    boxId: PropTypes.string.isRequired
};

export default PrintMac;



// WEBPACK FOOTER //
// ./data/components/PrintMac.js